import {request} from "../core/utils/request"
import * as account from "./account"

export const APIs = {
  request,
  account,
}

